/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Manual_Record_Aria_LabelInputs */

const en_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select manual record`)
};

const fr_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'enregistrement manuel`)
};

const de_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuelle Aufzeichnung auswählen`)
};

const it_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona record manuale`)
};

const ru_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите запись, записанную вручную.`)
};

const es_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar registro manual`)
};

const zh_cn2_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择手动记录`)
};

const ja_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手動記録を選択`)
};

const hi_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैन्युअल रिकॉर्ड चुनें`)
};

const pt_pt2_voices_manual_record_aria_label = /** @type {(inputs: Voices_Manual_Record_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione registro manual`)
};

/**
* | output |
* | --- |
* | "Select manual record" |
*
* @param {Voices_Manual_Record_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_manual_record_aria_label = /** @type {((inputs?: Voices_Manual_Record_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Manual_Record_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voices_manual_record_aria_label(inputs)
	if (locale === "de") return de_voices_manual_record_aria_label(inputs)
	if (locale === "it") return it_voices_manual_record_aria_label(inputs)
	if (locale === "ru") return ru_voices_manual_record_aria_label(inputs)
	if (locale === "es") return es_voices_manual_record_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voices_manual_record_aria_label(inputs)
	if (locale === "ja") return ja_voices_manual_record_aria_label(inputs)
	if (locale === "hi") return hi_voices_manual_record_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voices_manual_record_aria_label(inputs)
	return en_voices_manual_record_aria_label(inputs)
});